const ENGLISH_TRANSLATION = {
  home: {
    confront: {
      title: `CONFRONT YOUR DATA`,
      title_2: "AND VIEW THEM IN DASHBOARD",
      section_text_1:
        "Does analyzing and managing all your company's data and business rules seem impossible? Intelligent dashboards are simple and assertive solutions to help you control and monitor financial processes, improving the quality of information, reducing costs and preventing vulnerabilities.",
      section_text_2: "Try it free for 14 days. No credit card required.",
    },
    business_assurance_section: {
      title: `WE ARE A BUSINESS ASSURANCE PLATFORM`,
      section_text: `Connect any form of data source into a single Data Source and create attractive and interactive dashboards, where you can automatically share with your employees, suppliers and customers. Watch our video. Learn more about Hyaia and what we can do.`,
    },
    who_we_are: {
      title: "WHO WE ARE",
      section_text_1: `We are a company focused on revenue recovery and guarantee, through consulting and technology, we aim to provide the customer with increased financial and operational efficiency in business. In addition to identifying and dealing with possible irregularities (fraud and losses).`,
      section_text_2: `With personalized service to our customers, we have become a reference in the areas of telecommunications, retail, industry and health. We have a qualified team able to identify demands and provide the best results for your business, using a unique technology with a high degree of processing.`,
      section_text_3: `We are currently present in the lives of thousands of people. As our customers, we help on their journey to digital evolution, through consulting or developing solutions, providing services with quality and commitment.`,
    },
    hyaia_gathers: {
      title: `HYAIA BRINGS TOOLS THAT MAKE FLEXIBLE RESOURCES AVAILABLE IN ONE PRODUCT, GUARANTEEING AUTONOMY TO THE BUSINESS AREA`,
    },
    for_whom: {
      business_man: {
        title: "FOR BUSINESSMEN",
        section_text: "Better data quality for decision making",
      },
      business_architects: {
        title: "FOR BUSINESS ARCHITECTS",
        section_text: "Revolution in integrated BA & BI",
      },
      consultants: {
        title: "FOR CONSULTANTS                ",
        section_text: "Increase your service offer",
      },
    },
    differential: {
      title: "WHAT IS OUR DIFFERENTIAL?",
      section_text:
        "Hyaia makes Business Revenue Assurance easy for any line of business or business segment. Our agile and innovative technology allows a complete view of everything that happens in the operational and financial chains of your projects. This allows for better, faster and smarter analysis for decision making. Keeping the Data Lake as the only point of authenticity.",
    },
    how_it_works: {
      title: "HOW IT WORKS?",
    },
    step1: {
      title: "EASY DATA CONNECTION",
      section_text: "Simple connection to any database, regardless of format.",
    },

    step2: {
      title: "APPLICATION AND PROCESSING OF BUSINESS RULES",
      section_text:
        "Once connected, all operational and financial policies, strategies and business rules are entered into the platform and applied to the database.",
    },

    step3: {
      title: "RESULT IN DASHBOARDS & WORKFLOWS",
      section_text:
        "Every irregularity, financial loss, risk exposure and performance are presented in dashboards and workflows.",
    },

    step4: {
      title: "DATA ANALYSIS AND DECISION-MAKING",
      section_text:
        "With the results offered, in real time or near real time, your decisions will be more precise, assertive and will increase your profits.",
    },

    lets_start: {
      title: "LET'S START?",
      section_text: `Start tracking your business from end to end.`,
    },

    customer_testimonials: {
      title: "LARGE CLIENTS AROUND THE WORLD",
      section_text:
        "See what our customers think about Hyaia's performance in their business:",
    },
  },
  suport: {
    title: "DEVELOPMENT & INTEGRATIONS",
    section_text:
      "Apply Machine Learning algorithms straight from your database. Add dashboards to portals and mobile apps or add real-time integration to any external system.",
    list_api_advantages: {
      api_advantages: {
        title: "WHAT ARE THE ADVANTAGES OF AN API?",
        section_text:
          "Countless! The APIs (Application Program Interface) make it possible to manage most of Hyaia's functions through its own application.",
      },

      mobile_apps: {
        title: "DEVELOP MOBILE APPLICATIONS",
        section_text_1:
          "Want to have your own mobile app for reports and dashboards, with your branding or logo?",
        section_text_2:
          "Through our Live Links and API you can build and showcase your mobile app, on all major platforms.",
        section_text_3:
          "Add an entire report module to your mobile app in moments.",
      },

      dashboards: {
        title: "BUILT-IN DASHBOARDS",
        section_text_1:
          "With our Live Links and API you can create and embed directly into your web apps.",
        section_text_2:
          "Pass your parameters and security, and make interactions that take them directly to the main application.",
      },
    },

    list_data: {
      realtime_data: {
        title: "REAL TIME DATA",
        section_text_1:
          "As soon as new data arrives, you will be able to see them, at the same time, in our dashboards through our API.",
        section_text_2:
          "Our APIs are excellent for monitoring new information, processes and rules in sales, support tickets, IoT and many other critical items, in real time.",
      },
      data_management: {
        title: "MANAGE YOUR DATA",
        section_text:
          "Control your information through your applications through our APIs. Create an automated control center for data updates and additions. Schedule management: monitoring, triggering or pausing them.",
      },
      interactive: {
        title: "MAKE IT INTERACTIVE",
        section_text:
          "Add filters and dynamic analysis for your users to manipulate dashboards and access answers to their business questions. Filter data by team or user.",
      },
      process_automation: {
        title: "AUTOMATED PROCESSES",
        section_text:
          "Schedule publications and alerts. We strategically develop all data updates and dashboards distribution for you.",
      },
    },

    want_know_more: {
      title: "WANT MORE INFORMATION?",
      section_text:
        "Get in touch with our technical team and learn how to authorize, reference and use our API endpoints.",
    },
  },

  tickets: {
    title: "ONLINE ASSISTANCE & SUPPORT TICKETS",
    section_text:
      "Get access to all of your company's rules and processes with our online resources.",
    resources: {
      title: "ACCESS ALL OUR RESOURCES",
      section_text_1:
        "Our support team is here to provide you with all the information you need about Hyaia.",
      section_text_2:
        "Do you want to know more about Hyaia? Get in touch with us through our service channels.",
    },

    online_support: {
      title: "ONLINE ASSISTANCE",
      section_text:
        "We do everything from connecting data, preparing and transforming information to advanced visualizations.",
    },

    content_faq: {
      title: "FAQ WITH CONTENT",
      section_text_1:
        "We solve your most current doubts in the FAQ (Frequently Asked Questions) online. ",
      section_text_2:
        "You quickly access answers to your specific questions, such as:",
      section_text_3: "'How is the connection to my database performed?'",
    },

    support_tickets: {
      title: "CONNECTED SUPPORT TICKETS PROGRAM",
      section_text:
        "Get a support ticket for our experts to help you with your solutions. Our team is recommended by our customers for their quality and support.",
    },
  },

  chat: {
    title: "TALK DIRECTLY WITH OUR EXPERTS",
    section_text:
      "Get assistance from our team of solution experts, right from your account with the help chat, through our website.",
    chat_expert: {
      title: "NEED A HAND? CHAT NOW WITH ONE OF OUR EXPERTS",
      section_text_1:
        "Having trouble unwinding? Trying to remember a rule or process for creating your dashboards?",
      section_text_2:
        "At Hyaia we offer the help you need to visualize your information as much as possible.",
    },

    need_help: {
      title: "IN THE PLACE YOU NEED IT",
      section_text_1:
        "With Hyaia it will be possible to: learn a new solution, create rules and processes and become an expert in reliable data.",
      section_text_2:
        "Through our integrated chat, you can immediately speak with our team of business analysts and Hyaia experts. To help with:",
      section_text_3: "How to start using our platform.",
      section_text_4: "Visualization and data connection.",
      section_text_5: "Creation of rules and business processes.",
      section_text_6: "Installation and automation programming.",
      section_text_7: "Clear doubts instantly.",
      section_text_8: "And much more.",
      section_text_9:
        "Our integrated chat is accessible with some license levels, and with an option to access others.",
    },

    governance: {
      title: "ENJOY EVERY VOLUME OF GOVERNANCE",
      section_text_1:
        "Our team can show you how to get the most out of our technology on your data.",
      section_text_2: "We help you to enhance:",
      section_text_3: "The power of automation",
      section_text_4: "Management of rules and processes",
      section_text_5: "Dashboards and KPIs",
      section_text_6: "And other BRA features from our amazing platform.",
    },

    customer_testimonials: {
      title:
        "BE ACCOMPANIED, IN ALL YOUR PROCESSES AND RULES, BY OUR SUPPORT TEAM",
      customer_testimonial_1: {
        section_text_1: "I had no idea it would be this fantastic.",
        section_text_2: "",
        section_text_3: "",
      },
      customer_testimonial_2: {
        section_text_1:
          "Before, I had to do a lot of reconciliations, use a lot of systems, pay a lot for audits and wait a long time to see the results. When I put Hyaia on, everything that happened in the company came to me in real time. It felt like I was in another world, because of so much technology and professionalism from Hyaia.",
        section_text_2: "Mike Owens",
        section_text_3: "CEO",
      },
      customer_testimonial_3: {
        section_text_1: "We dramatically increased our profit margins.",
        section_text_2: "",
        section_text_3: "",
      },
      customer_testimonial_4: {
        section_text_1:
          "After we deployed Hyaia to challenge our business rules and processes. We began to detect all the sources of the company's financial loss, managing to stop them surgically and quickly. We even receive anticipation of problems, to take preventive measures. Our profit has increased, the company is growing more and our shareholders are happy.",
        section_text_2: "Louise Monreau",
        section_text_3: "CFO",
      },
    },
  },

  modules: {
    title: `KNOW OUR MODULES`,
    subtitle_desc: `Discover what the best and only multimarket technology in the world, in Business Revenue Assurance, can for you.`,
    audit_text_1: `Audit 100% of your database and find all non-compliance and financial losses in your business.`,
    audit_text_2: `Have accurate and reliable reports, in real time, for decision making that will solve your adversities in a timely manner.`,
    fraud_text: `Locate, in real time, any fraud condition in your business. Hyaia is the best and most modern anti-fraud system. Ensuring agility and precision in the detection of irregularities.`,
    compliance_text: `The corporate governance of your business is carried out by Artificial Intelligence, in real time. Don't lose certifications or receive fines for non-compliance. Hyaia is the best controller your business can have.`,
    indicator_text_1: `A KPI generator and OKRs created from the audited data.`,
    indicator_text_2: `Compare your indicators through the results shown by the INDICATOR.`,
    dashboard_text: `Your audit, fraud, discrepancies and risk exposure reports in interactive dashboards. With a modern layout for quick and crucial decision making.`,
    chatbot_text: `Interactive robots for better monitoring, alerts and notifications about your processes, rules and corporate policies.`,
    analysis_text_1: `A revolutionary technology, in Deep Learning, for tuning processes, rules and anticipating problems, which reduce your profit margins.`,
    analysis_text_2: `Prevention is better than cure, this module analyzes and indicates the path for the future of your business, with a high percentage of success.`,
    bigdata_text_1: `Your data organized, centralized and converted into clear and quality information.`,
    bigdata_text_2: `The best in Big Data technology is in Hyaia.`,
    machine_learn_text_1: `A revolutionary module in understanding and learning your business.`,
    machine_learn_text_2: `With each process, rule or corporate policy, Hyaia's Machine Learning learns and memorizes what it is taught. No retraining or user replacement required.`,
    scheduler_text_1: `A customizable scheduler for your data audits, about your rules and processes.`,
    scheduler_text_2: `Audit all the time or in certain periods, you decide what is best in your time and need.`,
    workflow_text_1: `Receive alerts, in scalability, of all audited executions in your base.`,
    workflow_text_2: `Know which broken rules, procedural or corporate policies will be instantly notified until the issue is resolved.`,
    security_text_1: `Ensure full protection of your audit.`,
    security_text_2: `Security inspects and monitors each technology user, showing reports of who made the accesses and what their actions were. Even turning off some feature or tool audit rule.`,
    security_text_3: `Your business is protected at all times.`,
  },
  buttons: {
    demo_btn_text: "Get a Free Trial",
    demo_btn_alternative_text_1: "Get a Free Trial",
    demo_btn_alternative_text_2: "FREE TRIAL",
    more_btn_text: "Learn more",
    contact_us_text: "Contact us",
    send_button_text: "Send",
  },

  examples: {
    title: "SEE ABOUT HYAIA'S PERFORMANCE IN MULTI SECTORS",
    section_text:
      "Discover a little of what the best technology in Business Revenue Assurance can do for your company.",
    telecom_sector: {
      billing_policy: {
        title: "BILLING POLICY ASSURANCE: ",
        section_text: "VALIDATION OF THE POST PAYMENT BILLING PROCESS",
        needs: {
          title: "Demand:",
          section_text_1: "Analysis of invoices by year.",
          section_text_2: "Increased control coverage map.",
          section_text_3: "Cost reduction per invoice.",
        },
        solutions: {
          title: "Solution:",
          section_text:
            "Deployment of our technology for Billing Policy Assurance.",
        },
        results: {
          title: "Results:",
          section_text_1: "Drop in the BBB (Better Business Bureaus) Ranking.",
          procon_text: "",
          section_text_2: "Team focus on exception handling.",
          section_text_3: "Operating cost reduction.",
        },
      },

      charging_policy: {
        title: "CHARGING POLICY ASSURANCE: ",
        section_text: "VALIDATION OF THE PREPAID CHARGING PROCESS",
        needs: {
          title: "Demand:",
          section_text_1: "Promotional minutes tariff analysis.",
          section_text_2: "Customer eligibility analysis x promotions.",
          section_text_3: "Measuring the financial impact of divergences.",
        },
        solutions: {
          title: "Solution:",
          section_text:
            "Deploying our technology for Charging Policy Assurance.",
        },
        results: {
          title: "Results:                    ",
          section_text_1: "100% customer analysis.",
          section_text_2: "80% reduction in process time.",
          section_text_3: "Execution of the process with 10% of the headcount.",
        },
      },
    },

    health_sector: {
      title: "HEALTH",
      section_text: "",
      cost_policy: {
        title: "COST POLICY ASSURANCE: ",
        section_text: "COST ANALYSIS OF MANAGED PROCEDURES",
        needs: {
          title: "Demand:",
          section_text_1: "Evaluation of 100% of managed procedures.",
          section_text_2: "Cost and margin analysis of procedures.",
          section_text_3: "Identification of non-compliance with the protocol.",
        },
        solutions: {
          title: "Solution:",
          section_text:
            "Implementation of our technology for Cost Policy Assurance.",
        },
        results: {
          title: "Results:",
          section_text_1: "Analysis of 100% of managed protocols.",
          section_text_2: "Online analysis of procedures.",
          section_text_3: "Cost analysis scale gain.",
        },
      },

      policy_assurance: {
        title: "MEDICAL PROTOCOL POLICY ASSURANCE: ",
        section_text: "DEVIATION ANALYSIS IN MEDICAL PRACTICE",
        needs: {
          title: "Demand: ",
          section_text_1:
            "Apply analytical intelligence to attendance information.",
          section_text_2:
            "Identify and standardize the consumption profile in medical practices.",
          section_text_3:
            "Identify deviations in the standard of medical care.",
        },
        solutions: {
          title: "Solution:                    ",
          section_text:
            "Deployment of our technology for Medical Protocol Policy Assurance.",
        },
        results: {
          title: "Results:",
          section_text_1: "Analysis of 100% of medical appointments.",
          section_text_2: "Cost reduction and detailed view of offenders.",
          section_text_3:
            "Improved communication of the hospital's strategic alignment.",
        },
      },
    },

    retail_sector: {
      title: "RETAIL",
      section_text: "",
      crm_policy: {
        title: "CRM POLICY ASSURANCE ",
        section_text: "VALIDATION OF THE CUSTOMER LOYALTY PROCESS",
        needs: {
          title: "Demand:",
          section_text:
            "Validate the granting of discounts based on the loyalty strategy.",
        },
        solutions: {
          title: "Solution:",
          section_text:
            "Implementation of our technology for CRM Policy Assurance.",
        },
        results: {
          title: "Results:",
          section_text_1: "Analysis of 100% of product purchase transactions.",
          section_text_2:
            "Reduction of losses due to improper granting of discounts.",
          section_text_3: "90% reduction in transaction analysis time.",
        },
      },

      logistics_policy: {
        title: "LOGISTIC POLICY ASSURANCE: ",
        section_text: "VALIDATION OF THE DRUG DISTRIBUTION PROCESS",
        needs: {
          title: "Demand:",
          section_text_1: "Evaluation of the product distribution process.",
          section_text_2:
            "Analyze and compare purchase orders and product delivery flow.",
        },
        solutions: {
          title: "Solution:",
          section_text:
            "Implementation of our technology for Logistic Policy Assurance.",
        },
        results: {
          title: "Results:",
          section_text_1: "Analysis of 100% of product purchase orders.",
          section_text_2: "Analysis of the distribution process.",
          section_text_3:
            "Gain in productivity and greater efficiency in operation.",
        },
      },
    },

    know_more: {
      title: "WANT TO KNOW MORE?",
      section_text:
        "Get in touch with our commercial team. And find out how to solve your business concerns with Hyaia.",
    },
  },

  corp_chain: {
    title:
      "DON'T BE HOLDAGE TO YOUR WORRIES, EXAMINE THE CORPORATE CHAINS OF YOUR BUSINESS        ",
    analyze_corp_chain: {
      title: "EXAMINE THE CORPORATE CHAINS OF YOUR BUSINESS",
      section_text_1:
        "Every large organization has its procedures, precepts and corporate policies, arranged in chains of processes.",
      section_text_2:
        "Managing, monitoring, evaluating and auditing each of them seems like a huge job. ",
      section_text_3:
        "With Hyaia your business rules cycle can be checked in real time. Receive instant alerts of any rule or process breach.",
    },

    realtime_process: {
      title: "EVERY PROCESS AND RULE SEEN IN REAL TIME",
      section_text:
        "Monitor and track everything that happens in your corporate chains. View information on interactive dashboards with each data update.",
    },

    fin_chain: {
      title: "FINANCIAL CHAIN",
      section_text_1:
        "Your organization's financial management is monitored and audited end to end. Rules for any business model, aimed at reducing costs and increasing profit.",
      section_text_2:
        "Do not pay for duplicate notes, double-tax taxes, guides with incorrect calculations and among other things, that may be unduly paid.",
      section_text_3:
        "Put your rules on Hyaia and let her monitor. You will be notified if there is any possible mistake in your finances.",
    },

    op_chain: {
      title: "OPERATIONAL CHAIN",
      section_text_1:
        "Imagine monitoring, measuring the level of performance and results, optimizing rules for all your business operations.",
      section_text_2:
        "Hyaia is the best technological solution, able to perform this task and generate reports, in real time, on everything that happens in your company.",
    },

    corp_policies: {
      title: "CORPORATE POLICIES",
      section_text_1:
        "The policies that govern your business are followed, checked and monitored by the best in Business Revenue Assurance with A.I.",
      section_text_2:
        "Eliminate risks and leave your company always in accordance with the law, and with the rules of business with your customers.",
    },
  },

  database: {
    title: "HYAIA COMES WHERE YOU NEED IT",
    section_text_1: "If your data is in the Cloud or On-Premise, no problem.",
    section_text_2:
      "Our technology, non-intrusive, reaches its bases and performs the processes.",
    data_protection: {
      title: "THE PROTECTION OF YOUR DATA IS OUR PRIORITY",
      section_text_1:
        "An innovative tool in data reading and report conversion.",
      section_text_2:
        "Obeying the GDPR, your data will be protected and safe, through our information reading connections.",
    },

    in_cloud_db: {
      title: "IN CLOUD",
      section_text:
        "If your information is in the cloud, through VPN connections, Hyaia performs data analysis on its own base. It converts into dashboards and reports in real time, ensuring your security.",
    },

    on_premise: {
      title: "ON PREMISE",
      title: "ON PREMISE",
      section_text_1:
        "If your database is physical, our team of specialists will go to them. Following all the necessary procedures, so that the reading of the elements is done in a safe and assertive way.",
      section_text_2:
        "Our technology does not import any material. It just reads and converts them externally into reports and dashboards, for better decision-making.",
    },
  },

  rapid_dashboard: {
    title: "AGILE & EASY DASHBOARD DESIGNER",
    section_text:
      "Convert raw data into ideas, quickly and easily, with our customer dashboard. No installation required!",
    drag_and_drop: {
      title: "DRAG & DROP DASHBOARD DESIGNER",
      section_text_1:
        "Without the right tools to bridge connections, meanings and insights, data is just numbers. Hyaia makes it possible to convert information into dashboards with our powerful intuitive designer.",
      section_text_2:
        "Start seeing performance, slopes, anticipations and results through charts, KPIs, spreadsheets and more. With our drag-and-drop dashboard look, you can create dashboards in no time.",
      section_text_3: "APP with 'drag and drop' to place the Dashboard.",
    },
    data_visualization: {
      title: "MANY WAYS TO VIEW DATA",
      section_text_1:
        "Access a vast library of designer tools to help you bring your data to life.",
      section_text_2:
        "Develop your dashboards and impress your team and your customers through direct, impactful and pleasant presentations.",
    },

    impressive_dashboards: {
      title: "EXTRAORDINARY DASHBOARDS",
      section_text_1:
        "Reports and dashboards must be attractive, direct and objective. Valuing the areas that need to be analyzed constantly.",
      section_text_2:
        "Dashboards with modern, clear and objective visuals, make it easy to read and impress your users.",
      section_text_3:
        "Identify patterns and outliers with well-designed dashboards, and instantly access the data you need.",
    },

    action: {
      title: "SEE IT IN ACTION",
      section_text_1:
        "Think about not having to “copy and paste” different types of data, and export text documents to get just a spreadsheet or a graph.",
      section_text_2:
        "Don't waste any more time! Start your journey through Hyaia and access the future.",
    },

    widgets: {
      title: "DATA VISUALIZATION WIDGETS",
      section_text_1:
        "Various types of graphics. Merge a column bar with a line chart. A spreadsheet, simple or complex, for clear presentation.",
      section_text_2:
        "Filter data or run a business rule with an input widget. Insert titles, images and videos and make it look great.",
      section_text_3:
        "Highlight a gauge, key indicator number, bullet chart or display information on Google Maps.",
      section_text_4:
        "Discover your dashboard design skill, and go further with our editors.",
    },

    auto_update: {
      title: "AUTOMATIC UPDATE",
      section_text_1:
        "Every update, deletion or addition of data in your dashboard will be immediately updated.",
      section_text_2:
        "Hyaia oversees all information and updates every connected panel.",
    },

    fast_interaction: {
      title: "INTERACT IMMEDIATELY",
      section_text:
        "With Hyaia, your information is accessible in just one click. Zoom in, filter or drill down and see what you need.",
    },

    custom_dashboards: {
      title: "CUSTOMIZED DASHBOARDS",
      section_text:
        "Put your face on the look of any dashboard. Maintain the identity of your brand, company or customer. And develop fonts, colors, backgrounds and more.",
    },
  },

  realtime_data: {
    title: "REAL TIME DATA",
    section_text_1:
      "Updating your data minute by minute is paramount, but being faster than that is sometimes more than necessary.",
    section_text_2:
      "Hyaia has APIs that can trigger upgrades to your databases or directly use our APIs to add and update your latest rows of data instantly",
    what_is: {
      title: "WHAT IS REAL-TIME DATA?",
      section_text_1:
        "It is information immediately available after being surveyed or assigned.",
      section_text_2:
        "The delay is practically zero between the moment it is created and the moment it is seen on your dashboard.",
    },
    apis_and_webhooks: {
      title: "API & WEBHOOKS",
      section_text_1:
        "Develop, submit, update or delete business rules, strategic and operational policies, in real time or near real time, in your process chain.",
      section_text_2:
        "Through our data terminals, you can have full control of your data groups and present your dashboards until the next information.",
      section_text_3:
        "Using our REST data endpoints, you can take ownership of your datasets and display your dashboards down to the second piece of information.",
      section_text_4:
        "Apply our AUDIT and WORKFLOW modules to check your data and detect non-compliance, rule breaking, fraud and performance performance in your dashboards.",
    },

    triggers: {
      title: "DATA UPDATE TRIGGERS",
      section_text_1:
        "Enable data updates, partial or full data uploads, any occurrence outside of Hyaia with our API endpoint connections.",
      section_text_2:
        "Configure your grouping of data or sources, and activate according to demands based on any occurrences, your applications or user actions.",
    },

    notifications: {
      title: "ALERTS & NOTIFICATIONS",
      section_text_1:
        "Through the WORKFLOW module, you can develop mobile and innovative apps for the Web that perform immediate notifications and alerts, displaying management dashboards in real time.",
      section_text_2: "With our “SCHEDULER” you can call external APIs.",
    },

    data_push_and_pull: {
      title: "DATA PUSH AND PULL",
      section_text:
        "Send real-time data (push) or trigger a data refresh (pull) and let Hyaia collate your data as you choose.",
    },

    send_data: {
      title: "SEND DATA IN REAL TIME",
      section_text_1:
        "With the help of Hyaia's API ends, you can transfer data from any client, app or other integration tools in real time.",
      section_text_2:
        "A new information is added to a spreadsheet or your CRM, and you can instantly check, in your dashboards, and visualize the returns.",
    },
    load_data: {
      title: "REAL-TIME DATA UPLOAD",
      section_text_1:
        "If your apps are unable to send data through our API, they can inform Hyaia to get the data. Instead of sending your information to Hyaia, you will send a notification to access data from numerous sources and update your dashboards.",
      section_text_2:
        "Agile, intuitive and easy to deploy, Hyaia does all the work.",
    },
  },

  data_management: {
    title: "DATA MANAGEMENT MADE EASY",
    section_text:
      "Conciliate, confront, audit, clean, merge your data with Hyaia, in its ETL platform, practical and easy to use.",
    reconcile: {
      title:
        " MUCH MORE THAN JUST DATA VISUALIZATION, AN ETL TOOL             ",
      section_text_1:
        "Once Hyaia is connected to your databases, your company is ready to convert the data into useful information. Hyaia is a powerful Data Source, capable of cleaning, reconciling, confronting, standardizing, enriching and combining countless data sources.",
      section_text_2: "",
      section_text_3:
        "Is your need an audited column that your source information is still full of nonconformities? Develop on Hyaia and every time your data is upgraded, the audits will also be updated.",
      section_text_4:
        "Maybe you need information grouped in a specific way? Create a grouping in Hyaia and it will always be synced and immediately available to view on your dashboards.",
    },

    datasource: {
      title: "SANITIZED DATA",
      section_text_1:
        "Organizing your information for use in dashboards isn't always straightforward. Getting all your data uniform and ready to be visualized, in a spreadsheet or graph, is an arduous task and requires a lot of manual intervention of information.",
      section_text_2:
        "Hyaia addresses these anxieties with our standardization and data sanitization tools. Our Big Data module ensures that all of your text data is in the correct case, with no extra spaces or that your dates are not in 1719 or 2399. This Machine Learning module allows all non-compliant values to be converted to one, for example “US”, “U.S.” and 'USA', which can be automatically converted to 'United States'.",
    },

    agile_connection: {
      title: "CONCILIATE, MERGE & COMBINE DATA",
      section_text_1:
        "Do you have a need to match your sales targets with your current sales figures? Imagine connecting passive data to output data? Our Hyaia Audit, Machine Learning, Big Data tools allow you to reconcile and combine information from multiple sources into a single spreadsheet.",
      section_text_2:
        "All merged elements remain in sync with the individual groups of information, so you don't have to match again. Just update each individual data source and the composite of information will be rectified.",
    },

    data_integrity: {
      title: "TRANSFORM DATA",
      section_text:
        "The analytics module allows you to use familiar business rules, strategic and operational policies, to create tuning or new orders. Authorizing Hyaia to analyze your databases, without having to change your original data.",
    },

    merge_data: {
      title: "MERGE DATA",
      section_text_1:
        "Examine the same aspects across multiple teams, systems, and geographies, and bring them together in one pool of data. Do it affordably and automatically with our data join.",
      section_text_2:
        "Hyaia represents facts allowing each end user to support their own content in their chosen and private way. You can join data to create differentiated and complete dashboards.",
    },

    easy_integration: {
      title: "EASY INTEGRATION",
    },

    cloud_or_onpremise: {
      title: "WHERE IS YOUR DATA ?",
      cloud: {
        title: "IN CLOUD?",
        section_text:
          "No problem, we are a SaaS tool and we make connections directly to your Cloud.",
      },

      onpremise: {
        title: "IN YOUR INFRASTRUCTURE?",
        section_text:
          "We connect physically, to your database or servers, promoting results in near real time.",
      },
    },
  },

  datasources: {
    title: "DATA SOURCES",
    section_text:
      "Combine and compare all your organization's data in one place, ensuring consistency and quality in data with agility, ease of generating indicators, such as dashboards and reports.",
    reconcile: {
      title: "CONCILIATE, CONFRONT AND SANITIZE YOUR DATA IN ONE PLACE",
      section_text:
        "Work with Hyaia to unify your data reading and auditing in one place. Build interoperability between different pools of data and different systems to work with. Impute your external apps, such as R and SPSS, for a deep and assertive analysis of your information.",
    },

    datasource: {
      title: "BENEFITS OF A DATA SOURCE",
      section_text_1:
        "Avalie a imagem e classificação externas da sua empresa através da Hyaia.",
      section_text_2:
        "Totalmente fácil de usar e intuitivo, o nosso assistente de conexão de dados te orientará a conectar as suas contas de mídias sociais e analisa-las em minutos.",
    },

    agile_connection: {
      title: "AGILE CONNECTION",
      section_text:
        "Hyaia has unique technology, its own 4th generation language, high digital power and connection to any type of data source. Provides access, in real time or near real time, to analyzes of all parameters of your company. Ensuring a quick response whatever the adversity that consumes your profit margin.",
    },

    data_integrity: {
      title: "DATA INTEGRITY",
      section_text:
        "Through our technologies, in Big Data, the quality and integrity of your data will be increasingly profound and totalitarian. Showing the origin, reason and compliance whatever the information.",
    },

    easy_integration: {
      title: "EASY INTEGRATION",
      section_text_1:
        "Regardless of your system, app, platform, database or API, from a complex ERP or CRM to a txt file, Hyaia manages to integrate information from each of them simultaneously.",
      section_text_2:
        "Decreasing non-interoperability, promoting reconciliation, confrontation and end-to-end application of business rules and corporate policies in your company.",
    },
  },

  interactive_dashboards: {
    smart_dashboards: {
      title: "INTERACTIVE & SMART DASHBOARDS",
      section_text:
        "Transform your data into surgical information with our smart dashboards, and make assertive decisions for your business.",
    },
    fully_interactive: {
      title: "FULLY INTERACTIVE DASHBOARDS",
      section_text_1:
        "In just one click, incorporate cross-referencing information with details into your charts, KPIs and tables. Show sub-tables and numerous dashboards. Expand and collapse graphs or shift timescales. Group by months, semesters or years.",
      section_text_2: "",
    },
    click_and_filter: {
      click: {
        title: "CLICK & FILTER",
        section_text_1:
          "Choose a column from a bar chart and filter the worksheet next to it. Select an indicator and go to another dashboard, with more information about it.",
        section_text_2:
          "Click on a row in a worksheet and expose the entire dashboard. See everything easily configured through the interactions tab, through the manifestations of each widget.",
      },
      users_and_teams: {
        title: "TEAM & USER PARAMETERS",
        section_text_1:
          "What is your need? 4 Dashboards? One for each hierarchical level of your organization or per released sector, according to each user's access rule?",
        section_text_2:
          "Define the parameters of each user on the platform itself and control your charts, according to each user's need and release.",
      },
      table: {
        title: "IMPROVEMENT TABLES",
        section_text_1:
          "Through our drill-down worksheets and functional widgets, drill down into any grouping of data, while keeping advanced-level summaries clear and available.",
        section_text_2: "No need to configure anything, just drag and drop.",
      },
      easy_nav: {
        title: "NAVIGATE EASILY",
        section_text_1:
          "Develop your navigation between dashboards, external applications, websites, videos and images.",
        section_text_2:
          "Use menus with buttons, groups of buttons, graphics, images and indicators.",
        section_text_3:
          "Show a more sophisticated data story by developing a trail on your metrics.",
      },
    },
    easiest_tool: {
      title: "AN EASIER AND SMARTER TOOL FOR REPORTING",
      section_text_1:
        "Hyaia can report when there are deviations from performance in its operational rules, processes and policies.",
      section_text_2:
        "Use your time building leads and spend less energy on spreadsheets.",
    },
  },

  partners: {
    title: "PARTNERSHIPS",
    section_text:
      "We work with market leading partners in technology and innovation, and we understand that relationships help to increase our level of competitiveness.",
  },

  reports: {
    title: "REPORTS IN THE PALM OF YOUR HAND",
    section_text_1:
      "Get access to your company's reports in the palm of your hand in real time or near real time.",
    section_text_2:
      "Hyaia allows you to access your information from anywhere with our smart dashboards.",
    access_form: {
      title: "ACCESS WHEREVER YOU ARE",
      section_text_1:
        "Install the app for iOS or Android and see your dashboards everywhere.",
      section_text_2:
        "Fully responsive, our dashboards adapt to different screen sizes. Either via WI-FI or your data network, you will have access to your reports whenever you want.",
    },
    our_apps: {
      title: "WITH OUR APP YOU CAN…",
      section_text:
        "We are always updating and adding features to our app, both for Android and iOS.",
      functionalities_list: {
        dashboards_text: "Visualize your dashboards",
        filter_text: "Filter, drill down and zoom in",
        notifications_text: "Receive notifications",
        export_pdf_text: "Export in PDF",
        send_email_text: "Send by email",
      },
    },
    suitable_apps: {
      title: "PERFECT APP FOR TABLET",
      section_text: "In the version for tablets. Available on Android and iOS.",
    },
    potency: {
      title: "SMALL IN SIZE, GIANT IN POWER",
      potency_smartphone: {
        section_text_1:
          "Ideal for achieving performance KPIs, smartphones are excellent in this format.",
        section_text_2:
          "Easily access spreadsheets and charts with a great look. Secure your data at your fingertips.",
      },
      potency_tablet: {
        section_text_1: "Get more views from your tablet screen.",
        section_text_2:
          "More recent tablets guarantee greater interaction, with their touch pens, on our dashboards.",
        section_text_3:
          "Perfect for demos, sales or meetings. Impress with our dashboards.",
      },
    },
  },

  scheduling: {
    title: "AUTOMATION, SCHEDULING & ALERTS",
    section_text:
      "Your data is automatically updated and published in dashboards and workflow, based on occurrences, all resulting from our Business Revenue Assurance technology.",
    know_everything: {
      title: "KNOW EVERYTHING THAT HAPPENS IN YOUR BUSINESS",
      section_text:
        "Leave your data up to date and receive alerts when any business rule, operational policy, fraud detection or other non-compliance is broken by our workflow module. Solve your annoyances quickly and improve your company's processes.",
    },

    kpis: {
      realtime_kpis: {
        title: "REAL TIME KPIs",
        section_text:
          "Confront your KPIs with our INDICATOR module, and see, in real time or near real time, our KPIs on your data and compare them with your business indicators.",
      },

      alerts: {
        title: "REAL-TIME ALERTS FOR NON-COMPLIANCE",
        section_text:
          "Monitor 100% of your business processes and rules, and receive real-time alerts on fraud, breaches of rules and processes, financial loss and non-compliance.",
      },

      data: {
        title: "DATA AND RULES OF YOUR CUSTOMERS MONITORED INSTANTLY",
        section_text_1:
          "Ensure the interoperability and communication of your customers' processes and rules. Hyaia is able to monitor, audit and supervise all its customers' contractual policies, generate alerts and notifications when there is a risk and threat. In this way, preventing breaches of contract, fines, risk to your company's image and loss of customers. ",
        section_text_2: "Expand your productivity.",
      },

      manage: {
        title: "FOLLOW THE PERFORMANCE DEVELOPMENT OF YOUR BUSINESS",
        section_text:
          "Be more agile, monitoring your processes, sectors and teams. Follow the flow of your company and make strategic and assertive decisions, based on the information generated by Hyaia.",
      },

      data_automatization: {
        title: "DATA AUTOMATION",
        section_text:
          "Set and forget. Hyaia's data automation ensures that your data and information is consistently fresh across all your sources. Weekly, every day and every minute.",
      },

      data_update: {
        title: "DATA UPDATE",
        section_text:
          "Its reports and dashboards are updated with each new imputed data. All analyzed, audited and reconciled with its processes, rules and corporate policies.",
      },
    },
  },

  connectors: {
    title: "DATA CONNECTORS",
    section_text:
      "Hyaia connects with all types of databases, systems, files and information bases, regardless of format, empowering it as an inclusive technology.",
    reconcile: {
      title: "NEED TO CONCILIATE AND CONFRONT YOUR DATA?",
      section_text:
        "Wherever your data is (spreadsheets, txt, app, database, cloud or physical location) Hyaia can connect with all of them simultaneously. And apply your organization's business rules, strategic and operational policies. Detecting if any: irregularity, exposure to risk, fraud and financial losses.",
    },
    business_apps: {
      title: "BUSINESS APPLICATIONS",
      section_text_1:
        "Do your management apps have valuable data? Can you read, reconcile and confront them in real time?",
      section_text_2:
        "Hyaia's secure connections can do that, as well as generate indicators and workflows, about any eventuality that your database has and that affects your organization's profits.",
      section_text_3:
        "Don't waste time and money, start tracking your company in the palm of your hand.",
    },
    social_media_connectors: {
      title: "SOCIAL MEDIA CONNECTORS",
      section_text:
        "Evaluate your company's image and external rankings by Hyaia. Totally easy to use and intuitive, our data connection wizard will help you connect your social media accounts and analyze them in minutes.",
    },
    cloud_connectors: {
      title: "CLOUD & ONPREMISE DATABASE",
      section_text:
        "If you have a database, either in the cloud with a terabyte in Google Big Query or Amazon RedShift, in a local Oracle or MySQL relational database, and you want to reconcile and confront them in real time, seeing everything in dashboards, we have the right answer to your need.",
    },
    spreedsheet: {
      title: "SPREADSHEETS & TEXT FILES",
      section_text_1:
        "Companies will always have an important part of their data in spreadsheets and text files, due to the simplicity of the most basic database.",
      section_text_2:
        "At Hyaia, our connectors make it possible to read, reconcile and compare, in an easy and fast way, to various data storage services. Even your emails can be aggregated and turned into dashboards.",
    },
    web_services: {
      title: "WEB SERVICES & APIS",
      section_text:
        "Hyaia is an incredible tool, whatever your integration. Through our Web Service Connector, we can connect to any API, REST or SOAP, using different types of authentication, from Basic to OAuth2 or AWS Signature. Regardless of whether APIs, which require parameters or macros, can be used for full power and automation. See solutions like: XML, JSON or Delimited.",
    },
    thousands: {
      title: "CONNECT TO THOUSANDS OF APPLICATIONS THROUGH HYAIA",
      section_text:
        "At Hyaia you can reconcile and collate data workflows from numerous applications simultaneously.",
    },
    safe_information: {
      title: "YOUR INFORMATION IS SAFE",
      section_text:
        "Don't worry, your data is not imported. Our solution reads all the data from its original source, and generates all the necessary dashboards, workflows and reports, in real time, through VPN connections. Only you and authorized persons have access to the information read by Hyaia.",
    },

    customer_testimonials: {
      title: "LARGE CLIENTS AROUND THE WORLD",
      section_text:
        "See what our customers think about Hyaia's performance in their business:",
    },

    lets_go: {
      section_text: `Don't waste time and start using the best technology in the world in BRA.`,
    },
  },

  health: {
    title: "YOUR FINANCIALLY HEALTHY HOSPITAL",
    section_text:
      "Track, from end to end, all procedures, health insurance, pharmacy, recurrence, contracts and increase your organization's profits for exponential growth.",
    perform_better: {
      title: "RUN YOUR SPECIALTY BETTER WITH REAL-TIME DATA",
      section_text_1:
        "Find ways to reduce costs, increase service quality and optimize patient care.",
      section_text_2:
        "With up-to-date reports, you have access to accurate and correct information on any aspect of your healthcare service.",
    },
    medical_bill_list: {
      medical_bill: {
        title: "MEDICAL BILLS",
        section_text_1:
          "Concile and audit in real time medical records, contracts, completion of forms and agreements.",
        section_text_2:
          "Cut costs, keep finances organized, correctly receive the amounts passed on by the health insurance or private consultations. Thus reducing medical glosses.",
      },

      management_procedures: {
        title: "MANAGED PROCEDURES",
        section_text:
          "With high computational power and its own 4th generation language, Hyaia monitors and guarantees the set of necessary care and administrative actions, sufficient for the full performance of surgical procedures. Contemplating human resources, physical facilities, equipment, instruments and input materials inherent to the care process.",
      },

      pharmacy: {
        title: "PHARMACY",
        section_text:
          "Ensure the safe and rational use of prescribed medications, meeting the demands of hospitalized patients. Greater control and no waste, all in the right measure.",
      },

      profit: {
        title: "BILLING",
        section_text_1:
          "Accounts checked, audited and proven before being forwarded to health operators.",
        section_text_2:
          "Greater agility in sending invoices, and speed in receiving payments.",
      },

      glosa: {
        title: "DISALLOWANCE OF CREDITS",
        section_text:
          "Put an end to communication problems, and have accurate reports in real time. Minimize the gloss in your healthcare organization as much as possible.",
      },
      contracts: {
        title: "CONTRACTS",
        section_text_1:
          "Ensure the rules of each contract and have a profitable hospital management.",
        section_text_2:
          "Automatically enforce your healthcare organization's contract rules, and monitor all established compliance parameters in real time.",
      },
    },
  },

  industry: {
    title: "YOUR MORE PRODUCTIVE COMPANY WITH LESS EXPENSES",
    section_text_1:
      "Use Hyaia to manage and monitor all your departments, production, operational and financial chains of your business.",
    section_text_2:
      "See, in real time, everything that is lost and recovered in your daily actions in the company.",
    economy: {
      title: "EVERY CENT SAVED ON YOUR PRODUCTION LINE CAN BECOME MILLIONS",
      section_text_1:
        "Promote the tuning of your process chain and improve your business rules in your production lines, making it faster and cheaper.",
      section_text_2:
        "Through Deep Learning technology, Hyaia can increase your profits and bring incredible results to your company.",
    },

    artificial_inteligence: {
      title: "ARTIFICIAL INTELLIGENCE IN YOUR BUSINESS",
      section_text:
        "With our technologies, from Business Intelligence, Business Revenue Assurance, Big Data, Machine Learning, Deep Learning and Internet Of Things, have a better view and greater control of processes, rules, departments, supply chain, reverse logistics, WMS, MRP1, MRP2 , inventory, EMII, CMN among other important factors of your organization.",
    },

    consulting: {
      title: "AUDIT AND CONSULTING",
      section_text_1:
        "Count on our teams of consultants and technology to assist in structuring processes, rules and policies, optimizing the examination of your business for accurate and real-time reports.",
      section_text_2:
        "Promote Revenue Assurance in your company's operational and financial chains.",
      section_text_3:
        "Audit your ERP, CRM, WMS, Risk & Compliance and tax systems.",
    },

    antifraud: {
      title: "ANTI FRAUD",
      section_text:
        "Protect your business and detect any fraud in real time. Every penny can make a difference in the end.",
    },

    kpis: {
      title: "KPIS & OKRS",
      section_text_1:
        "Confront your company's KPIs and OKRs with accurate and reconciled data.",
      section_text_2:
        "Hyaia can generate indicators based on the audited data and compare them with the indicators of its systems, showing discrepancies to improve performance.",
    },

    workflow: {
      title: "REAL-TIME PROBLEM WORKFLOW",
      section_text_1:
        "Get notified immediately of every irregularity that consumes your profits.",
      section_text_2:
        "With Hyaia you receive alerts, in real time, with a degree of scalability until the problem is solved.",
      section_text_3: "The faster the action the smaller the loss.",
    },
  },

  retail: {
    title: "GUARANTEE PROFITS IN B2C",
    section_text:
      "Have a complete view and follow, in real time, everything that happens in your retail business.",
    numerous_processes: {
      title:
        "COUNTLESS PROCESSES IN RETAIL SEEM SOMETHING IMPOSSIBLE TO CONTROL, WITH HYAIA THIS IS NOT A PROBLEM",
      section_text_1:
        "Follow, in real time, the performance of your store, e-commerce and omnichannel.",
      section_text_2:
        "Reconcile your database and solve problems in record time with our interactive dashboards.",
    },
    product_performance_list: {
      product_performance: {
        title: "PRODUCT PERFORMANCE",
        section_text:
          "See how your products are performing, across all sales channels, in real time. Automatic updates will ensure you are always in the know.",
      },
      inventary_control: {
        title: "INVENTORY CONTROL",
        section_text:
          "Keep inventory low, relate to predictive models, track items on the shelf more easily, and keep all prices up to date with one dashboard, in real time.",
      },
      profit_up: {
        title: "INCREASE IN PROFITS",
        section_text:
          "Save a lot by having an overview and detailed view of your entire business.",
      },
      orders: {
        title: "ORDERS & BILLING",
        section_text: "Monitor all orders and invoices through intelligent dashboards, real-time reports, within your company's corporate rules and policies.",
      },
      analysis: {
        title: "ANALYSIS OF E-COMMERCE INDICATORS",
        section_text:
          "Accurate KPIs of your online business in real time. Make decisions and create strategies to reach goals with essential and reliable indicators.",
      },
      customer: {
        title: "CONQUERING CUSTOMERS",
        section_text:
          "Quickly discover which sales were effective. Track your conversion rates, new customer traffic, centralize revenue and optimize your marketing strategies.",
      },
    },
  },

  telecom: {
    title: "THE NEW AND BEST CONCEPT IN BRA FOR TELECOM",
    section_text_1: "With Hyaia telecom interoperability is possible.",
    section_text_2:
      "Improve your processes and data quality with our technology. Optimizing your profits, revenue, cash flow without influencing service demand.",
    invoice: {
      title: "IRRECONCILABLE INVOICES CAN BE EXPENSIVE",
      section_text_1:
        "Through Hyaia, your customers' invoices and plans will be correct and unambiguous.",
      section_text_2:
        "Each client will have a plan and a rule. Have the best in BRA to monitor and manage individually.",
      section_text_3:
        "Get real-time reports on dashboards and show them to your team to improve your company's management.",
    },
    cdr_list: {
      cdr: {
        title: "CDR",
        section_text_1:
          "Audit all your customers' call log information, applying the rules of each plan on each call.",
        section_text_2:
          "Full control of your customers' calls can be a great source of savings, profits and protection against improper customer billing.",
      },

      routing: {
        title: "INCORRECT INTERNET ROUTING",
        section_text_1:
          "Data delivery for each plan must be effective and monitored, ensuring profit for the company and customer satisfaction.",
        section_text_2:
          "Hyaia can check and notify routing failures. Communicating to the operator, in real time, situations that create problems between the client and the Telecom company, undermining its profits, risk and image.",
      },

      business_rules: {
        title: "INACCURATE BUSINESS RULES",
        section_text_1:
          "See which rules are invalid, unhelpful or outdated in your system with Hyaia.",
        section_text_2:
          "Promote a tuning of rules and processes, so that your service flow is increasingly assertive and more profitable.",
      },

      subscriptions: {
        title: "SUBSCRIBER PROVISIONING",
        section_text_1:
          "Identify the degree of functionality and clarity of provisioning for your operator's subscribers.",
        section_text_2:
          "Follow through the interactive dashboards the behavior of the systems in relation to the implantation or adaptation of services to its users.",
        section_text_3:
          "Detect configuration or systemic installation errors, and take action in advance, ensuring the level of satisfaction of your subscribers.",
      },

      precision_errors: {
        title: "CLASSIFICATION AND BILLING ACCURACY FAILURES",
        section_text_1:
          "Check, in real time, the business rules on pricing, billing and negotiation according to the size of each customer.",
        section_text_2:
          "Put an end to discrepancies, risk exposure, financial losses and fraud with the help of our modules.",
      },
    },
  },

  education: {
    title: "WITH HYAIA YOUR EDUCATION SYSTEM IS A GRADE A+",
    section_text_1:
      "Educational institutions have numerous processes with numerous rules to ensure the quality, management and control of the workflow and student demand. Not to mention systems, spreadsheets, history and other data, which are of paramount importance to the entity through regulatory bodies such as the ED (Education Department).",
    section_text_2:
      "Ensuring the fluency of your educational institution's educational and financial cadence is our specialty.",
    e2e_control: {
      title: "END TO END CONTROL",
      section_text:
        "Our technology is not intrusive, Hyaia communicates with any database and in any format. Performing the reading and application of processes, rules and corporate policies of your organization, generating reports in real time through modern and interactive dashboards.",
    },

    financial_list: {
      financial: {
        title: "FINANCIAL",
        section_text_1: "Monitor and audit your accounts in real time.",
        section_text_2:
          "Know where, when and how every penny is in your educational institution.",
        section_text_3: "Cut costs, find scams and watch your profits soar.",
      },
      register: {
        title: "ENROLLMENT",
        section_text_1:
          "Ensure the management of your students enrollments, monitoring payments, contractual clauses, student inflows and outflows through reliable indicators in real time.",
        section_text_2:
          "Make quick and assertive decisions for the expansion of your educational institution.",
      },
      student_allocation: {
        title: "LEASE OF CLASSES",
        section_text_1:
          "Monitoring and managing classes is not an easy task, infinite factors can enhance or deconstruct classes from their educational motivation.",
        section_text_2:
          "Hyaia ensures that its rules, for formation, location, monitoring and development of classes, are monitored and reported in the best possible way.",
      },
      history: {
        title: "SCHOOL RECORDS",
        section_text_1:
          "Grades, absences, averages, approvals, recoveries, capstone project (undergraduate thesis), multiplied monographs considering the number of students, it is an immense educational chain to control and monitor, even seeming impossible in real time.",
        section_text_2:
          "But with Hyaia this can be easily solved, your school transcript rules along with your processes can be monitored and reported, in real time, ensuring the effectiveness of your academic work and the satisfaction of your students.",
      },
    },
  },

  ecommerce: {
    title: "YOUR E-COMMERCE IS ALWAYS EFFICIENT AND GENERATING PROFIT",
    section_text_1:
      "Online sales are the future, more than 56% of physical retail sales are influenced by some kind of digital channel these days.",
    section_text_2:
      "However, ensuring interoperability between the physical and digital chain in e-commerce is not so simple.",
    section_text_3:
      "Hyaia is the best solution to keep track of your e-commerce processes and rules.",
    fast_efficient: {
      title: "DIGITAL, FAST AND EFFICIENT",
      section_text:
        "See in real time all the processes, rules and corporate policies of your e-commerce, inspected and audited in the entire database of your technologies.",
    },

    card_fraud_list: {
      fraud: {
        title: "CREDIT CARD FRAUD",
        section_text:
          "Detecting fraudulent purchases and being notified immediately, guarantee the credibility of your sales. Avoid merchandise losses and sales cancellations.",
      },
      logistics: {
        title: "LOGISTICS",
        section_text_1:
          "With Hyaia's modules like Big Data, Machine Learning and Deep Learning, you can cut costs and increase your profits.",
        section_text_2:
          "Know where, how and in which State your products are, from the regiment to delivery to the final customer.",
      },

      reverse_logistics: {
        title: "REVERSE LOGISTIC",
        section_text_1:
          "Receiving a returned product involves a series of procedures, rules and processes that cost money. And it is more expensive when you do not have end-to-end control of reverse logistics and the guarantee of monitoring your corporate policies.",
        section_text_2:
          "Track, in real time, where and how your products are in the return process, cut costs, optimize processes and increase your profit margins.",
      },

      churn: {
        title: "CHURN",
        section_text_1:
          "How much is a customer who gives up on your brand, product or service worth? Even more expensive is if he defames your e-commerce.",
        section_text_2:
          "Understanding and monitoring, via indicators, why and how many of your customers are not buying from you is something that Hyaia provides for your business, so that you can make decisions and convert losses into loyalty.",
        section_text_3:
          "Increase your portfolio and have the best word of mouth for your company, with the information generated by Hyaia.",
      },
    },
  },

  public_sector: {
    title: "INCREASE IN COLLECTION AND PERFORMANCE OF THE PUBLIC MANAGEMENT",
    section_text:
      "Hyaia can optimize the municipality's sources of revenue, and monitor the performance development of departments and public sectors.",
    mgnt: {
      title:
        "PUBLIC MANAGEMENT IS NOT SO SIMPLE, BUT VIA HYAIA EVERYTHING IS POSSIBLE",
      section_text_1:
        "The public sector has several sectors, with infinite processes, different rules and management policies. The amount of data and systems for this demand is high, and tracking all of them, multiplied by the population, is even more difficult.",
      section_text_2:
        "Hyaia is the best system for monitoring and managing processes in the public sector. Promoting more results that will be converted into benefits for the population.",
    },

    warranty_list: {
      warranty: {
        title: "TAX GUARANTEE AND RECOVERY",
        section_text_1:
          "With a processing capacity of more than 20 billion data crossings/day, it discovers underpaid taxes with corrections, fines and updated reports.",
        section_text_2:
          "Have, in real time, updated municipal revenue sources for actions that will benefit the population.",
      },
      service_high: {
        title: "PERFORMANCE OF DEPARTMENTS, SERVICES AND SECTORS",
        section_text:
          "Follow, compare and see the development of sectors and municipal or state departments in real time. Comparing indicators and optimizing the speed of processes and agility of public services.",
      },
      digital_reports: {
        title: "DIGITAL REPORTS",
        section_text_1:
          "Reduce costs by sharing information with your time, your constituents, your residents and taxpayers.",
        section_text_2:
          "Through Hyaia it presented instantaneous dashboards in digital format.",
      },
      performance_dashboard: {
        title: "PERFORMANCE DASHBOARD",
        section_text:
          "With interactive dashboards, get an overview of tracking and managing team time. Filter by vendor project, team or team user.",
      },
      project_status: {
        title: "PROJECT STATUS MONITORING",
        section_text:
          "Project managers can use this dashboard to track all KPIs, all the way to project completion: phases completed and time left to complete.",
      },
    },
  },
  financial_services: {
    title: "THE BEST OPTION IN BRA FOR YOUR FINANCIAL INSTITUTION",
    section_text_1:
      "The goal of every company is to make a profit, achieve its vision of its values, and accomplish its mission.",
    section_text_2:
      "Achieving goals, guaranteeing revenues and reducing costs are fundamental pillars for any financial institution.",
    section_text_3:
      "Hyaia is the best choice for auditing business processes and rules, ensuring increased profit in your organization.",

    monitor_account: {
      title: "MONITORING ON YOUR OWN ACCOUNT",
      section_text_1:
        "Thousands of customers means thousands of processes, rules, situations, annoyances and solutions.",
      section_text_2:
        "Monitoring and following up on a case-by-case basis, plus countless financial processes, with 100% efficiency seems unfeasible, but with Hyaia this is possible.",
    },

    compliance_list: {
      compliance: {
        title: "COMPLIANCE",
        section_text_1:
          "Risk and compliance for financial institutions are essential fundamentals. Reconciling balance sheets,  P&L (Profit and Loss Statement) , indexes, indebtedness, fundraising and converting them into reports that guarantee shareholder confidence is an extremely surgical and meticulous job.",
        section_text_2:
          "Reconciling balance sheets, P&L, indexes, indebtedness, fundraising and converting them into reports that guarantee shareholder confidence is an extremely surgical and meticulous job.",
        section_text_3:
          "With Hyaia you generate reports and dashboards, in real time, on the entire operational and monetary chain of your financial institution.",
        section_text_4: "Get the best in compliance technology.",
      },

      fraud: {
        title: "FRAUD",
        section_text_1:
          "Whether internal or external, fraud can come from anywhere, and the best option in the fight against fraud is a technology that can examine and monitor your entire organization, with policies and rules that prevent or detect any form of fraud as soon as possible irregularity.",
        section_text_2:
          "The best in anti-fraud AI is at Hyaia. Get notified immediately of every suspicious occurrence in your organization.",
      },

      customer_plans: {
        title: "CUSTOMER PLANS",
        section_text_1:
          "Guarantee contracts, rates, products and services agreed with your customers, keeping them satisfied and eliminating the degree of evasion.",
        section_text_2:
          "One happy customer is worth two. Word of mouth marketing is priceless.",
      },

      treasury: {
        title: "TREASURY",
        section_text_1:
          "Negotiations and applications of financial resources of your financial organization with much more assertiveness and foresight.",
        section_text_2:
          "Our modules not only ensure the monitoring and auditing of your institution's rules and processes, but also predict risk scenarios through Deep Learning technology.",
        section_text_3:
          "Better to be safe than sorry and your profit will be glad.",
        section_text_4:
          "Do not miss the opportunity and have Hyaia in your financial organization.",
      },
    },
  },

  publish_and_share: {
    title: "PUBLISH, SHARE & CONTRIBUTE",
    section_text:
      "Contribute to your dashboard through your team and customers with live links.",
    send_dashboards: {
      title: "SEND DASHBOARDS IN REAL TIME DURING LIVE LINKS",
      section_text:
        "Leave your dashboards ready and add a person or a team to the dashboard's security list, they will be alerted by email immediately. Hyaia has a scheduling system, which you configure to update your data and convert it into dashboards for regular spaces or specific dates. Your team can access dashboards in PDFs, images or Live Link - an innovation in sharing fully interactive dashboards.",
    },
    learn_to_share: {
      title: "LEARN TO SHARE",
      section_text:
        "Display your dashboards in the best possible way by sharing them with your team, partners and customers.",
    },

    email_list: {
      by_email: {
        title: "BY EMAIL",
        section_text:
          "Hyaia delivers its dashboards via email, as attachments in PDF, Live Link or image formats.",
      },
      intranet: {
        title: "VIA INTRANET",
        section_text_1:
          "Add your metrics straight to your internal collaboration software.",
        section_text_2: "Use live links as IFRAMES.",
      },
      automatic_reports: {
        title: "AUTOMATIC REPORTS",
        section_text_1:
          "Leave your reports configured and share your dashboards, to selected stakeholders, according to your choice.",
        section_text_2: "Expand your productivity.",
      },
    },
  },

  user_security_and_management: {
    title: "SECURITY & USER MANAGEMENT",
    section_text:
      "Manage each user's access and permissions on the platform and on your dashboards.",
    protection: {
      title: "USER AND TEAM PROTECTION",
      section_text_1:
        "With Hyaia, you control and monitor your team's access or data management, dashboards and reports.",
      section_text_2:
        "Organize people into teams, manage their access permissions for dashboards, rules and processes in our management area.",
      section_text_3:
        "Develop users for your team and clients. Include and keep your users directly in Hyaia. Import complete spreadsheets of your users or use our API in synchronization with Active Directory and LDAP.",
    },
    user_secrty: {
      title: "USER SECURITY",
      section_text:
        "Through viewer or editor licenses, you can configure the platform, according to each user's authorization level. From viewing dashboards, rules, processes and corporate policies to editing them.",
    },

    team_secrty: {
      title: "TEAM SAFETY",
      section_text:
        "Sort your users into teams and assign access rights for the entire group. Migrate users between teams instantly, assigning different data and visibility to dashboards and rules.",
    },

    user_params: {
      title: "USER AND TEAM PARAMETERS",
      section_text:
        "Through parameters, automatically filter the information of each dashboard for the user, according to the permissions of each team. Teams focus on the insights most relevant to them, without access to other users' data.",
    },
  },

  security: {
    title: "ADVANCED SECURITY",
    section_text:
      "Your data is safe and secure. Hyaia does not work with any type of data import. Using VPN connections your data is read, audited in the base and converted into reports and dashboards.",
    company_info: {
      title:
        "ADVANCED SECURITY FOR YOUR COMPANY'S DATA, DASHBOARDS AND INFORMATION",
      section_text_1:
        "The protection of your data and information is our top priority.",
      section_text_2:
        "Our advanced security features allow you to customize your policies, according to your business's corporate standards. Integrating your favorite provider and identity.",
      section_text_3:
        "Authentication is one of the security locks. Our Trust Center team is increasingly committed to ensuring that processes, people and tools remain in line with security regulations such as SOC 1, 2 and 3, ISO 27001, and respect for privacy regulations such as ADPPA, GDPR , HIPAA among others.",
    },
    steps: {
      sso: {
        title: "SINGLE SIGN-ON (SSO)",
        section_text:
          "Make it easy for all users to use the same username and password through Single Sign-On.",
      },
      two_factor: {
        title: "TWO-FACTOR AUTHENTICATION",
        section_text_1:
          "Connect to Hyaia through your cell phone and ensure your user's protection.                ",
        section_text_2:
          "Through 2FA authentication, you will have access with one more layer, in addition to your name and password.",
      },
      tracking_session: {
        title: "SESSION TRACKING",
        section_text_1:
          "View all activities for each user. Notice when, how and what each one is doing.                ",
        section_text_2:
          "Track access to your information by user, IP address, date/time and action.                ",
      },
      whitelist: {
        title: "WHITELIST POR IP",
        section_text:
          "Our Whitelisting feature by IP allows only certain IP addresses to be able to access your dashboards or applications.",
      },
      log_tracing: {
        title: "SMART LOG ANALYSIS",
        section_text:
          "We analyze login usage and automatically block accounts with repeated failed attempts or locations not approved by you.",
      },
      password_rules: {
        title: "PASSWORD RULES",
        section_text:
          "Strong, smart, complex passwords that are rotated frequently. Minimum character size, uppercase and lowercase letters, symbols, numbers and all options.",
      },
    },

    rest_api: {
      title: "A SIMPLE AND SECURE REST-BASED API",
      section_text:
        "Simple and powerful are Hyaia's APIs. You who are the developer will love working with our API, creating innovative applications, fast interfaces extending your user interface to include dashboards. Everything you need is in our online API reference, right down to an endpoint creative area.",
    },
  },

  awards: {
    title: "AWARDS",
    section_text:
      "We are committed to always offering quality and safe solutions to our customers. That's why we are recognized as the best multisector technology in the world in Business Revenue Assurance. And we proudly list our awards:",
  },

  whitelabel: {
    title: "WHITE LABEL DASHBOARDS",
    section_text:
      "Benefit from Hyaia's White Label (OEM) services and applications and make it part of your business.",
    dashboard: {
      title: "ADD WHITE LABEL DASHBOARDS WHERE YOU WANT",
      section_text_1:
        "Remove any mention of the Hyaia brand and replace it with your company's with our White Label feature.",
      section_text_2:
        "Delight your customers and team with analytics straight from your app and website.",
    },
    in_your: {
      crm: {
        title: "IN YOUR CRM PLATFORM",
        section_text:
          "Leverage your sales and service CRM by allowing your users to view customized dashboards created exclusively for them. Give them more customization, flexibility  and great-looking dashboards.",
      },
      erp: {
        title: "ON YOUR ERP PLATFORM",
        section_text:
          "Does your ERP not provide excellent reports? Add customized dashboards with data from your ERP, crossed with other databases, to get the best out of your system.",
      },
      portal: {
        title: "ON YOUR PORTAL",
        section_text:
          "As easy as copy and paste, Hyaia's dashboard integration is for you who use SharePoint or other software as a solution for your internal portal.",
      },

      site: {
        title: "ON YOUR WEBSITE",
        section_text_1:
          "Need dynamic graphics on your website? Or a KPI for your number of likes and visits?",
        section_text_2:
          "With Hyaia, and our public live links, give your web an analytical look.",
      },

      views: {
        title: "EMBEDDED VIEWS",
        section_text:
          "Embed interactive and dynamic dashboards directly from your portal or web app via our live links in moments. Copy and paste our iFrame code right into your web, and be ready to add dashboards to your app.",
      },

      app: {
        title: "IN YOUR CUSTOM APPLICATION",
        section_text:
          "Do you have a great B2B cloud application but can't build a reporting module around it? Have Hyaia added to your app, through iFrames and APIs, and impress your customers with your presentations.",
      },
      sso: {
        title: "SINGLE SIGN-ON (SSO)",
        section_text:
          "Through Active Directory connector or SAML integration, make your users time much easier by enabling single sign-on. Also use our API to sync users from your custom app to Hyaia and vice versa.",
      },
      two_way: {
        title: "TWO-WAY INTERACTIONS",
        section_text:
          "With your CRM application click on a graph, select the customer to view all sales orders for the same. The two-way interaction passes parameters between Hyaia's dashboards and your app.",
      },
    },
  },

  privacy_policy: {
    main_section: {
      first_tilte: "PRIVACY",
      second_title: "POLICIES",
      text: "We respect your data. It is our business to ensure that your data remains safe, private and secure. From a website visitor to a long-term customer, this is our privacy and cookie policy.",
    },
    introduction_section: {
      title: "INTRODUCTION",
      paragraph_1: "Your privacy is of paramount importance to Hyaia SAAS.",
      paragraph_2:
        "Hyaia provides a cloud-based service (the “Service”), which is a data analysis and reporting platform for storing, processing, interfacing and visualizing data through our web platform, API and mobile applications.",
      paragraph_3:
        "We fully respect your right to privacy regarding your interactions with the Service and are committed to being transparent in our dealings with you, about what personal information we collect and how we use your personal information.",
      paragraph_4:
        "Furthermore, we only collect and use personal information that is necessary to provide services for which we have a legal basis to do so.",
      paragraph_5:
        "We have created this Privacy Policy to describe our practices and procedures in handling “Personal Information” that we collect or receive from you.",
      paragraph_6:
        "The term “Personal Information” means any information that identifies, relates, describes or is capable of being associated with, or can reasonably be linked, directly or indirectly, to an identified or identifiable living natural person, including, but not limited to: ( i) Identifiers such as real name, pseudonym, postal address, unique personal identifier, IP address, email address, account name and (ii) information defined as “personal information”, “personally identifiable information”, “personal data ”, or similar expressions under applicable privacy laws or data security laws, which include the European Union General Data Protection Regulation (GDPR) among others.",
      paragraph_7:
        "This Privacy Policy covers three types of personal information:",
      list: {
        item_1:
          "“Site Information” means information collected while viewing pages on our websites, information you have entered in our contact, downloaded documents, job applications or other forms, referring URLs and IP address and similar data tracked both internally and by third parties;",
        item_2:
          "“Account-Related Information” means contact information, payment information and biographical information about our customers' representatives and contacts used for marketing, opening new user accounts to use our Services and to maintain existing accounts;",
        item_3:
          "“Account User Content Data” means data that you or your users are permitted to make, upload, connect, transfer, input or import into Hyaia for the purposes of use or the Service.",
      },
      paragraph_8:
        "Please read this Privacy Policy carefully. We will ask for your consent to be bound by this Privacy Policy as a condition of: (i) viewing our websites and (ii) testing or using our services.",
      paragraph_9:
        "Our website and services are intended for professionals and adults. We do not collect personal information from users under the age of 13, but we do make our services available to academic institutions.",
    },
    colected_data_section: {
      title: "COLLECTED DATA",
      sub_section_1: {
        sub_title: "Website Cookies",
        paragraph_1:
          "A cookie is a small file placed in your browser that allows us to improve your experience on Hyaia websites and applications by remembering your preferences and settings.",
        paragraph_2:
          "Hyaia cookies are used to store the language of the preferred/selected website, the website referring to the visitor, a unique identifier that can be traced back to the in-app session for activity reporting or for predefined patterns such as region and language preferences.",
        paragraph_3:
          "In addition, our website uses Google Analytics using Tag Manager, which tracks visitors, page-to-page activity and the duration of each page. We use these cookies to improve our website in terms of content and organization and to index it preferentially in Google search.",
      },
      sub_section_2: {
        sub_title: "Website Forms",
        paragraph_1:
          "Website forms are used to allow visitors to contact the sales team for business inquiries, job requests, and to forward requests for additional information or documents on related topics.",
      },
      sub_section_3: {
        sub_title: "Main account owner details",
        paragraph_1:
          "Users signing up for the study and/or paying subscriptions are required to enter a valid email address, first and last name, business name and telephone number as per the Terms of Use.",
        paragraph_2:
          "Users who do not wish to enter the above information correctly are not authorized to use our Service.",
        paragraph_3:
          "This information is collected and stored with the account to provide notification of service changes and to identify the account owner in the event of a data breach, data misuse or other issues related to the use of the Service.",
      },

      sub_section_4: {
        sub_title: "Account user data",
        paragraph_1:
          "Users who connect, send or enter data on Hyaia for analysis in the course of using the Service seek complete privacy of their data.",
        paragraph_2:
          "Hyaia adheres to a strong Privacy Policy for all of its employees and partners. This policy, in essence, prohibits accessing data without the user's express permission. This permission is logged and their account access is also logged and visible to the account owner.",
        paragraph_3:
          "The content of the data is not the responsibility of Hyaia, nor are we able to interpret this data, its origins and its use. When account access is provided, our responsibility is to help our customers resolve the issue.",
        paragraph_4:
          "We do not transmit, copy or move data from the original Data Center region to any other region or database. We do not allow access to data except for Microsoft Azure technical support team in case of system or database issues and are always supervised by Hyaia team.",
      },

      sub_section_5: {
        sub_title: "Account payment details",
        paragraph_1:
          "The primary account owner, when using our paid services, must add a payment method.",
        paragraph_2:
          "All other data such as: company name, billing address, VAT (Value Added Tax - or TVA in French) or tax identification numbers - company identifiers are required for accounting practices and used as such.",
      },
    },

    data_use_section: {
      title: "USE OF COLLECTED DATA",
      paragraph_1:
        "The data collected on the website is used to optimize it, changing the structure and content.",
      paragraph_2:
        "Data from forms such as Contact Us, Employment, Vision and Roadmap, Blog Registration, Download Assets such as Whitepapers and Documents are used to provide the required information to the requester.",
      paragraph_3:
        "Account user data is used to send product bulletins, system notifications, alerts, posts as scheduled by users or the system as needed but not exclusively for password resets, system limits, payment and invoices, new releases products, updates or downtime, security alerts and similar alerts.",
    },

    gdpr_section: {
      title: "GDPR",
      paragraph_1:
        "If you are a person in the European Economic Area, you may have the following rights under applicable data protection law and us as the Data Controller in relation to Account Related Information or other Personal Information covered by this Policy of Privacy, with such rights in relation to such Personal Information:",
      list: {
        item_1: "the right to access Personal Information relating to you;",
        item_2: "the right to correct any errors in your Personal Information;",
        item_3:
          "the right to object and ask us to stop contacting you with direct marketing;",
        item_4: "rights in relation to automated data processing;",
        item_5:
          "the right to restrict or prevent your personal information from being processed;",
        item_6:
          "the right to have your personal information ported to another data controller;",
        item_7: "the right to delete;",
        item_8:
          "the right to complain to the DPC if you believe that we have not handled your Personal Information in accordance with Applicable Data Protection law.",
      },
      paragraph_2:
        "If you are a user working on behalf of an existing Hyaia customer and we have your account-related information, under a contract with that customer, we have a legitimate interest in sending you electronic communications/direct marketing relating to the Service and related matters (which may include, but will not be limited to newsletters, announcement of new features, etc.).",
      paragraph_3:
        "We may also ask questions for different Services, including competition. And we may ask you to complete surveys that we use for research purposes, although you don't have to complete them. You can ask us to stop contacting you for direct marketing purposes.",
      paragraph_4:
        "If you would like to do this, please email support@hyaia.com directly or call one of the numbers available on the website. You can also click on the “Unsubscribe” button at the bottom of the electronic communication.",
      paragraph_5:
        "It may take up to fifteen (15) days for this to occur; and let us know the method of contact you are not happy with. And if you are unhappy with certain ways of contacting you (for example, you might be happy to be contacted by email but not by phone).",
    },

    protector_structure_section: {
      title: "EU-US PRIVACY GUARD STRUCTURE",
      paragraph_1:
        "As you have the option of storing the data in a data center in the EU or the US, we do not adhere to the EU-U.S. Privacy Shield as it does not apply. Your data, if you store it in the EU, will remain in the EU.",
    },

    retention_section: {
      title: "DATA RETENTION",
      paragraph_1:
        "Account-Related Information and other Personal Information will be retained and stored for such period of time as we deem necessary, taking into account the business purpose for which it was collected in the first instance (i.e. administering Your Account while Your Account is active and a reasonable period thereafter, should you choose to reactivate your account), and our obligations under applicable law to protect data protection.",
      paragraph_2:
        "This may include retaining Account-Related Information or other Personal Information as necessary to comply with our legal obligations, resolve disputes, enforce our agreements, support business operations and continue to develop and improve our Services.",
      paragraph_3:
        "Where we keep improving and developing personal information for services, we take steps to eliminate information that directly identifies you, and we only use the information to uncover collective insights about your use of our Service, not to specifically analyze personal characteristics about you.",
    },

    contact_section: {
      title: "GETTING IN TOUCH",
      paragraph_1:
        "If you need to contact us regarding any of your rights as set out in this Policy, all such requests must be made in writing and by email to support@hyaia.com.",
    },

    resolution_section: {
      title: "DISPUTE RESOLUTION",
      paragraph_1:
        "If you feel that we have not processed your personal information in accordance with this Privacy Policy, please contact us in the first instance. You can submit a complaint to us at support@hyaia.com.",
      paragraph_2:
        "Once we receive a privacy complaint, our privacy team will investigate your complaint and provide a response.",
      paragraph_3:
        "We will need sufficient information for us to assess your complaint and, as a result, we may ask you to provide us with additional information that we believe is necessary to assess your complaint.",
      paragraph_4: "The dispute resolution process will be in English.",
    },

    alterations_section: {
      title: "CHANGES TO THE PRIVACY POLICY",
      paragraph_1:
        "Hyaia may change its Privacy Policy from time to time and at its sole discretion. The date of the most recent revisions will appear on this page.",
      paragraph_2:
        "If you do not agree to these changes, please do not continue to use the Service to send us account-related or other personal information.",
      paragraph_3:
        "If material changes are made to the Privacy Policy, we will notify you by posting a prominent notice on our website or by sending you a notice in connection therewith.",
      paragraph_4:
        "We will not process account-related information in a manner not covered by this Privacy Policy without your consent.",
    },

    original_section: {
      title: "ORIGINAL PRIVACY POLICIES",
      paragraph_1:
        "This document in English is free to translate and does not overlap with the original document, used only to support the understanding of our customers. Questions about these policies should be directed to support@hyaia.com.",
    },
  },

  terms_of_use: {
    main_section: {
      first_tilte: "TERMS",
      second_title: "OF USE",
      paragraph_1:
        "The terms of use of our Service are described in this document, our obligations and if you agree to use our platform, as a test or as a customer.",
      paragraph_2:
        "It is very important that you read them and let us know your questions and concerns.",
    },
    terms_section: {
      title: "TERMS",
      paragraph_1:
        "These terms of use (“Terms”) cover your (“you” and “Customer”) use of and access to our services, client software and websites (collectively as “Services”) as of January 1, 2020.",
      paragraph_2:
        "By accepting these Terms, whether by registering on our websites, registering for a free trial or purchasing one of our subscriptions, clicking a box indicating your acceptance, or executing an order form or any other documentation that references this agreement, you agree to the terms of this agreement.",
      paragraph_3:
        "If you are entering into this agreement on behalf of a company or other legal entity, you represent that you have the authority to bind such entity and its affiliates to these terms and conditions, in which case the terms “you” or “your” refer to such entity and its affiliates.",
      paragraph_4:
        "If you do not have that authority or if you do not agree to these terms and conditions, you must not accept this agreement and you will not be able to use our Services.",
      paragraph_5: {
        first_text: "Our ",
        link_text: "Privacy Policy",
        second_text:
          " explains how we collect and use your information when using our Services. By using our Services, you agree to be bound by these Terms and our Privacy Policy.",
      },
      paragraph_6:
        "Our Data Processing Agreement (DPA) is an extension of the Terms, and explains our role as a Data Processor, our obligations and responsibilities to each other. By using our Services, you agree to be bound by these Terms and the DPA.",
    },
    update_use_terms_section: {
      title: "TERMS OF USE UPDATES",
      paragraph_1:
        "Hyaia reserves the right to update and change the Terms of Use at any time and without prior notice.",
      paragraph_2:
        "All new features that augment or enhance the current Service, including the release of new tools and features, will be subject to the Terms of Use. Your continued use of the Service after such changes will constitute your consent to such changes.",
      paragraph_3:
        "The Terms of Use set forth the entire understanding between you and Hyaia regarding the Service, and supersede any prior agreements between the parties (including, but not limited to, prior versions of the Terms of Service).",
    },
    services_section: {
      title: "SERVICES",
      paragraph_1: "Our Services allow the client to:",
      list: {
        item_1:
          "store data you choose to transfer to our databases and servers;",
        item_2:
          "edit, transform, combine, modify data to create views or additional data;",
        item_3: "create reports and dashboards from the provided data;",
        item_4:
          "publish the reports and dashboards along with the data to other users or the public.",
      },
      paragraph_2:
        "We may remove, temporarily suspend, modify and add any and all Services without prior notice.",
      paragraph_3:
        "Your use of the Service, including any content, information or functionality contained therein, is provided on an “as is” and “as available” basis, without representations or warranties of any kind, express or implied, including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose and non-infringement. You assume all responsibility and risk for your use of this Service.",
      paragraph_4:
        "Our Services allow the archiving or deletion of data at certain time intervals and depending on the subscription level. Hyaia is not responsible for any data loss and should not be considered a backup for critical data.",
      paragraph_5:
        "Our Services include features that allow you to connect to third party data, websites, applications and services. Hyaia is not responsible for the use of products provided by third parties, nor will Hyaia be affiliated with any of the third parties.",
      paragraph_6:
        "You can select different types of subscriptions and each one can have different features and functionality that may change over time.",
      sub_section_1: {
        title: "a) Personal, free and trial subscriptions",
        paragraph_1:
          "Hyaia may offer subscriptions that allow limited use of the Service in functionality or duration. Users of these subscriptions may be subject to advertising, limited functionality and reduction of Services and/or limits on data capacity.",
        paragraph_2:
          "These subscriptions may be removed to free up space for other accounts if they are not actively used for a certain period of time.",
        paragraph_3:
          "These subscriptions may be canceled at any time and without notice if these Terms are violated.",
      },
      sub_section_2: {
        title: "b) Non-profit or academic use-only subscriptions",
        paragraph_1:
          "Hyaia may offer subscriptions for free or at a reduced cost, which allow academic and not-for-profit use of our Services with limited functionality.",
        paragraph_2:
          "Users of this subscription may be subject to advertising, limited functionality and reduction of services and/or limits on data capacity, unless there are paying components of their subscription.",
        paragraph_3:
          "These account templates can be removed to make room for other accounts if they are not actively used by a particular period of time.",
      },
      sub_section_3: {
        title: "c) Paid subscriptions",
        paragraph_1:
          "Hyaia offers paid Services that allow you to use the Service. Users of this Service will have different features depending on their subscription level.",
        paragraph_2:
          "There are several levels of Service, depending on the degree and agreement between the Client and Hyaia. In general, the most basic tiers have lower performance, storage and capacity than the higher tiers, however they can change over time and can be replaced or modified on a case-by-case basis.",
      },
      sub_section_4: {
        title: "d) Functionality adopted early",
        paragraph_1:
          "We sometimes release products and features that are still being tested and evaluated. These Services will be marked as beta, preview, early access, or evaluation (or with similar words or phrases) and may not be as reliable as other services. Please use them at your own risk.",
      },
    },
    software_section: {
      title: "SOFTWARE",
      paragraph_1:
        "Some of our Services allow you to download client software (“Software”), which may be automatically updated. As long as you comply with these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license to use the Software solely to access the Services.",
      paragraph_2:
        "To the extent that any component of the Software may be offered under an open source license, we make that license available to you and the provisions of this license may expressly supersede some of these Terms.",
      paragraph_3:
        "Unless the following restrictions are prohibited by law, you agree not to reverse engineer or decompile the Services, attempt to do so, or assist anyone else to do so.",
    },
    content_section: {
      title: "CONTENTS",
      paragraph_1:
        "When using our Services, you may store files and data, as well as metadata (“Content”). These Terms do not give us the right to access, use or distribute your Content unless necessary to provide the Service.",
      paragraph_2:
        "Our Services also provide features such as search, metadata detection, or linking. These and other features may require our systems to access, store and digitize the Content.",
      paragraph_3:
        "You give us permission to carry out the processes, and that permission extends to our affiliates and trusted third parties that we work with.",
      paragraph_4:
        "Our Services allow you to share your content with others through dashboards and data through Live Links and similar features. We do not publish on your behalf and do not control the recipients of your content.",
    },
    use_section: {
      title: "ACCEPTABLE USE",
      paragraph_1:
        "The following describes actions that constitute unacceptable use of our Service and will result in the immediate termination and removal of your account and all content on our Service without notice, notification, refund or credit of any amounts already paid:",
      list: {
        item_1:
          "Use the Services to encourage illegal, abusive or other activities that interfere with Hyaia's and/or other customers' business or activities;",
        item_2:
          "Attempt to bypass or disrupt any security mechanism on any of the Services or use the Services in a manner that poses a security or service risk to Hyaia or one of its users;",
        item_3:
          "Reverse engineer the Services to find limitations, vulnerabilities or bypass filtering features;",
        item_4:
          "Use the Services in a manner that could subject Hyaia or third parties to liability, damage or danger;",
        item_5:
          "Launch or facilitate, whether intentionally or unintentionally, a denial of service attack on any of the Services or any other conduct that adversely affects the availability, reliability or stability of the Services;",
        item_6:
          "Transmit any material that contains viruses, “Trojan Horses”, worms or other malicious, harmful or dangerous programs;",
        item_7:
          "Using the Services to participate in or connect with fraudulent activities;",
        item_8:
          "Use the Services contrary to any Privacy Policy, including but not limited to HIPAA, PIPEDA and GDPR;",
        item_9:
          "Violate or facilitate the violation of any local, regional, provincial, state, federal or foreign law or regulation, including laws and regulations regarding the transmission of data or software;",
        item_10:
          "Take any action to participate in, encourage or promote any activity prohibited under these Terms of Use;",
        item_11:
          "Use the Service to send bulk email or spam to third parties without your consent or not in accordance with CAN-SPAM and similar guides;",
        item_12:
          "Use the Services to store or transmit any material that infringes the intellectual property rights or other rights of others;",
        item_13:
          "Use the Services to store or transmit any material that is libelous, defamatory, discriminatory or malicious or harmful to any person or entity;",
        item_14:
          "Use the Services or any component of the Services in a manner not authorized by Hyaia;",
        item_15:
          "Impersonate other users without permission or access any area of the Platform that you do not have permission to access.",
      },
      paragraph_2:
        "You and your company are responsible for your conduct and content and you must comply with all acceptable terms of use above.",
      paragraph_3:
        "We may review your conduct and content for compliance with these Terms. With that said, we are under no obligation to do so.",
      paragraph_4:
        "Protect your password for the Services, make sure others don't have access to it, and keep your account information up to date.",
      paragraph_5:
        "Finally, our Services are not intended for and may not be used by persons under the age of 13. By using our Services, you are representing to us that you are 13 years of age or older.",
    },
    communication_section: {
      title: "COMMUNICATION",
      paragraph_1:
        "You must provide your full name, a valid email address and other information as necessary to complete the enrollment and activation process. Invalid email addresses, names or company information is not an acceptable use of the Services.",
      paragraph_2:
        "Notwithstanding our Privacy Policy, and in order to provide the Service to you, Hyaia may communicate with you via email or telephone regarding your account, updates, news and other matters relating to your account. Please see our Privacy Policy for additional information.",
      paragraph_3:
        "You are responsible for maintaining the security of your account and password. Hyaia will never ask for your password or provide your password via email or any other means of communication.",
    },
    host_section: {
      title: "ACCOMMODATION",
      paragraph_1:
        "You understand that Hyaia uses third-party vendors and hosting partners to provide the hardware, software, information, network, storage and related technology necessary to run the Service.",
      paragraph_2:
        "Our Services are hosted or rely on the following providers:",
      list: {
        item_1:
          "Microsoft Corporation One Microsoft Way Redmond, WA 98052-7329 USA",
        item_2: "OVH 2 Rue Kellermann 59100 Roubaix France",
      },
    },
    service_availability_section: {
      title: "SERVICE AVAILABILITY",
      paragraph_1:
        "Hyaia will endeavor to make the Service available 99.5% of the year, but does not guarantee unless otherwise documented through a Business Customer agreement which voids these Terms.",
      paragraph_2:
        "Hyaia shall not be liable for any loss of data, business, revenue or property due to the Service being unavailable.",
      paragraph_3:
        "Unexpected failures caused by third parties including Microsoft Azure, OVH, Amazon and Google used by our infrastructure as well as any software or service we connect to do not count towards our Service availability metrics.",
      paragraph_4:
        "Upon request, we may, at our discretion, provide further details of the Service interruption in the form of a Service Interruption Report (SIR). A SIR may be issued in a limited manner or may not contain security and/or proprietary information.",
    },
    support_service_section: {
      title: "SUPPORT SERVICE",
      paragraph_1:
        "Hyaia endeavors to provide support to all Customers, within an acceptable time period, but does not guarantee this, unless otherwise documented through a specific Service Level Agreement agreement, overriding any all or parts of the Terms.",
    },
    clossing_section: {
      title: "CLOSING",
      paragraph_1:
        "You are free to stop using our Services at any time. We also reserve the right to suspend or terminate the Services at any time, in our sole discretion and without notice.",
      paragraph_2:
        "For example, we may suspend or terminate your use of the Services if you are not in compliance with these Terms or use the Services in a manner that could cause us to be legally liable, interrupt the Services, or disrupt a third party's use of the Services.",
      paragraph_3:
        "Except for paid subscriptions, we reserve the right to terminate and delete your account if you are not accessing our Services after a certain period of time.",
      paragraph_4:
        "Hyaia will provide you with notice via the email address associated with your account before we do so. We are not responsible for proper reception of email due to spam, rules, firewall or disabling notifications.",
      paragraph_5:
        "We reserve the right to accept or decline a customer. We have sole discretion as to whether or not to allow registration, renewal, change of plan or use of our Services.",
      paragraph_6:
        "To cancel an account, you must contact the Hyaia team directly via email or phone. Please use support@hyaia.com email address to cancel your account.",
      paragraph_7:
        "Your paid subscription will remain in effect until (i) it is canceled, or (ii) it is terminated under these Terms, or (iii) payment is not received at the end of each payment renewal cycle.",
      paragraph_8:
        "Cancelation of your account is immediate and will result in permanent loss of your data.",
      paragraph_9:
        "Hyaia will not be able to restore the account after a certain period of time nor recover any of your data. No credits or refunds will be given in the event of a cancellation initiated by the Customer, before the end of the billing period / subscription period.",
    },
    downgrade_section: {
      title: "Downgrade",
      paragraph_1:
        "Some subscriptions can be downgraded to a lower tier as long as the subscription does not exceed usage limits or available features, just the subscription level used.",
      paragraph_2:
        "Subscriptions that do not meet the requirements of the new target subscription grade will remain in the current subscription.",
      paragraph_3:
        "It is not Hyaia's responsibility to ensure that the requirements are met before changing the subscription. Records must be modified before the end of the billing cycle, and will be effective immediately upon modification.",
      paragraph_4:
        "No refunds or credits will be given for unused prepaid features or limits added to the initial subscription level. Data and functionality may occur when downgrading subscriptions, so please be careful before downgrading.",
      paragraph_5:
        "Some subscription levels cannot be downgraded, only canceled.",
    },
    upgrade_section: {
      title: "Upgrade",
      paragraph_1:
        "Adding options or upgrades that cause rates to increase will be charged to your credit card and are effective immediately. Not all subscription tiers can be upgraded or their options changed.",
    },
    prices_section: {
      title: "PRICES AND PAYMENT",
      paragraph_1:
        "Prices for all Services, including without limitation Service subscription plan fees, are subject to change without notice. Having said the above, we will try to notify all customers at least thirty (30) days in advance via email.",
      paragraph_2:
        "Acceptable payment methods are by bank transfer, credit card or PayPal. Payment by bank check agreed by both parties only.",
      paragraph_3:
        "All other payment methods will be declined and do not constitute payment. If you pay by credit card or PayPal and depending on your location, the payment will be handled by a US payment processor or a European payment processor.",
      paragraph_4:
        "You are responsible for all applicable taxes, bank fees, transfer fees, credit card fees, currency exchange fees, federal, regional, state, local taxes or any similar surcharges and surcharges imposed on or in connection with our Services.",
      paragraph_5:
        "For purposes of this section, taxes do not include taxes that are mandated or measured by Hyaia's income tax, property tax or payroll tax. You must notify us in writing if you dispute any part of any fees paid or payable by you. Under this agreement.",
      paragraph_6:
        "You must provide us with such written notice within sixty (60) days of the applicable fee and we will work with you to resolve the applicable dispute promptly.",
      paragraph_7:
        "If you do not provide us with this written notice of your fee dispute within this period, you will not be entitled to dispute any fees paid or payable by you.",
      paragraph_8:
        "If your use of our Services exceeds the amounts prepaid by you or if you fail to pay any amounts owed by you, we may suspend our Services associated with your account without notice.",
      paragraph_9:
        "We shall have no liability for any damages, liabilities, losses (including any loss of data or profits) or any other consequences that you may incur in connection with any suspension of our Services under this section.",
      paragraph_10:
        "If Service fees are not paid in a timely manner or if we are unable to process your transaction using the credit card information provided or using an alternative payment method, we reserve the right to revoke access to your account or downgrade your your account to a free account which may result in loss of data and/or resources.",
    },
    copyrigth_section: {
      title: "COPYRIGHT AND OWNERSHIP",
      paragraph_1:
        "Hyaia owns the intellectual property rights to all protected components of the Service, including but not limited to the name of the Service, the artwork and end-user interface elements contained in the Service, many of the individual features, and related documentation.",
      paragraph_2:
        "We welcome your feedback about our Services, however, by submitting suggestions or other comments about our Services (“Contributions”), you agree that:",
      list: {
        item_1:
          "we are under no obligation of confidentiality in relation to your Submissions;",
        item_2:
          "we may use or disclose (or choose not to use or disclose) your Contributions for any purpose and in any form;",
        item_3:
          "you irrevocably, non-exclusively grant us rights to exploit your Contributions;",
        item_4:
          "you are not entitled to any compensation or reimbursement of any kind from us under any circumstances for your Contributions.",
      },
      paragraph_3:
        "You may not copy, modify, adapt, reproduce, distribute, reverse engineer, decompile or disassemble any aspect of the Service.",
      paragraph_4:
        "Hyaia does not claim intellectual property rights in Content that you submit or provide to the Service.",
    },
    brands_section: {
      title: "BRANDS AND LOGOTYPES",
      paragraph_1:
        "Subject to these Terms, we grant each other the right to use and display each other's name and logo (the Licensor Marks) on our respective websites and in other promotional materials solely in connection with each of our respective activities under these Terms.",
      paragraph_2:
        "All such use of the Licensor Marks will be in accordance with each other's applicable usage guidelines and will ensure the benefit of the licensor.",
      paragraph_3:
        "Either of us using the other's Licensor Marks under this subsection shall not use, register or take other action with respect to any of the Licensor Marks, except to the extent permitted in advance in writing by one of us whose Licensor Marks are being used.",
      paragraph_4:
        "When using the Licensor Marks under this subsection, one of us using the Licensor Marks of the other will always use the current Licensor Marks and will not add, delete or modify any of the Licensor Marks.",
      paragraph_5:
        "Neither of us using the other person's Licensor Marks may, at any time, misrepresent the relationship between us.",
      paragraph_6:
        "Anyone using the other person's Licensor Marks will not represent themselves as an affiliate or other legal agent of one of us whose Licensor Marks are being used.",
      paragraph_7:
        "Rights to use and display each other's Licensor Marks under this subjection will automatically terminate in the event these Terms terminate or if either party requests removal of the name and logos from websites or promotional materials.",
    },
    confidentiality_section: {
      title: "CONFIDENTIALITY",
      paragraph_1:
        "Confidential Information means any information or data, whether in tangible form or in tangible form, disclosed by either party that is marked or designated as confidential or proprietary or that could otherwise reasonably be understood to be confidential given the nature of the information and the circumstances. surrounding publicity.",
      paragraph_2:
        "“Confidential Information” does not include any information that:",
      list: {
        item_1:
          "is publicly available through no fault of the receiving party;",
        item_2:
          "was duly known to the receiving party, without restriction, prior to disclosure by the disclosing party;",
        item_3:
          "was duly disclosed to the receiving party, without restriction, by another person without violating the rights of the disclosing party;",
        item_4:
          "is independently developed by the receiving party without use of or reference to the confidential information of the disclosing party.",
      },
      paragraph_3:
        "Each party agrees that it will use the other party's Confidential Information solely in accordance with the provisions of this Agreement, and will not disclose such information to third parties without the other party's prior written consent, except as otherwise permitted herein.",
      paragraph_4:
        "Each party agrees to exercise due care in protecting Confidential Information from unauthorized use and disclosure.",
      paragraph_5:
        "Each party may disclose the other party's Confidential Information, in whole or in part, to its employees, agents, actual or potential investors and subcontractors who have a need to know and are legally required to keep such information confidential in accordance with the terms of this document.",
      paragraph_6:
        "Either party may disclose the other party's Confidential Information as required by law, upon prior written notice to the other party (where permitted by law), provided that party uses its reasonable efforts to minimize such disclosure to the extent permitted by the applicable legislation.",
    },
    warranty_section: {
      title: "LIMITED WARRANTY / LIMITATION OF LIABILITY",
      paragraph_1:
        "The Services are provided “as is” and “as available”. Hyaia makes no express or implied warranties of any kind, including, without limitation, implied warranties of merchantability or fitness for a particular purpose.",
      paragraph_2:
        "No communication between the customer and Hyaia, written or oral, will create a warranty or in any way alter or restrict any warranty disclaimer or limitation of liability set forth in this section, or elsewhere in this agreement.",
      paragraph_3:
        "In no event will Hyaia be liable for loss of profits or other indirect, special, cover, exemplary, incidental or consequential damages arising out of or in connection with this agreement or the use of or inability to use the Service.",
      paragraph_4:
        "In no event shall Hyaia's liability for damages, losses or causes of action, whether in contract or tort, jointly or separately, exceed the total dollar amount paid by the customer to Hyaia during the twelve (12) months prior to the alleged damage or damage.",
      paragraph_5:
        "The limitations of liability described here and in subsection (b) below apply equally to liability for negligence:",
      list: {
        item_1:
          "Without limiting the generality of the foregoing, Hyaia shall have no liability for any claims or losses resulting from breaches of security, exposure of confidential or private data (except to the extent applicable law prohibits the limitation of such liability) or loss of data or data access.",
        item_2:
          "Hyaia is not responsible for the accuracy, veracity or validity of any data entered by the Customer or provided through the Service.",
        item_3:
          "Hyaia shall not be liable for interruption or delays in transmission of the Service caused by acts of God, terrorism, fire, water, riots, acts of Government, acts or omissions of Internet backbone providers or any other causes beyond Hyaia's control.",
        item_4:
          "Customer's sole and exclusive remedy, if you are dissatisfied with the Service or any of Hyaia's terms, conditions, rules, policies, guidelines and practices, discontinue use of the Service.",
        item_5:
          "Customer acknowledges and agrees that Hyaia has set its prices and entered into this Agreement in accordance with the limitations and exclusions of liability and warranty disclaimers set forth in this section and elsewhere in this Agreement (collectively, the “Limitations”) and that the limitations form a essential basis of the bargain between Hyaia and Client. The Limitations survive and apply even if Customer's remedies provided in this Agreement fail of their essential purpose.",
      },
    },
    idemnity_section: {
      title: "INDEMNITY",
      paragraph_1:
        "Customer will indemnify and hold Hyaia and its affiliates, employees, officers, directors, agents, licensors, successors and assigns harmless from all damages and liabilities, including, without limitation, attorneys' fees incurred as a result of:",
      list: {
        item_1: "Customer's breach of its obligations under this Agreement;",
        item_2: "Customer's negligent or intentional acts;",
        item_3:
          "For Customer's violation of the rights of third parties relating to the use or operation of the Service, including, without limitation, privacy rights, other proprietary rights, trade secret, proprietary information, trademarks, copyrights or patents, other intellectual property rights and claims for defamation, defamation or unfair trade practices.",
      },
    },
    applicable_law_section: {
      title: "APPLICABLE LAW",
      paragraph_1:
        "This contract is made with Hyaia SAS (registered in France - RCS 503 458 499).",
      paragraph_2:
        "These Terms will be governed by the laws of France, unless expressly agreed otherwise through a Customer Agreement.",
      paragraph_3:
        "You hereby expressly agree to be bound by the exclusive laws of France for the purpose of resolving any dispute relating to your access to or use of the Service.",
      paragraph_4:
        "Any questions regarding the Terms of Use should be directed to support@hyaia.com.",
    },
    aggremment_section: {
      title: "AGREEMENT TO ARBITRATE",
      paragraph_1:
        "Before bringing formal legal action, first try contacting our Customer Support, as most disputes can be resolved this way.",
      paragraph_2:
        "If we are unable to resolve our dispute through our Customer Support, you or any of your affiliates, on the one hand, Hyaia and any of Hyaia's affiliates, agree to resolve any dispute arising out of these Terms or Privacy Notices, or in regarding our Services by binding arbitration in France, or elsewhere to which we both agree.",
      paragraph_3:
        "You may only resolve disputes with us on an individual basis and may not file a claim as a plaintiff or class member in a class, consolidated or representative action. Class arbitration, class actions, private attorney actions and consolidation with other arbitrations are not permitted.",
    },
    original_terms_section: {
      title: "ORIGINAL TERMS OF USE",
      paragraph_1:
        "This document in English is free to translate and does not overlap with the original Term, used only for the purpose of supporting the understanding of our customers. Questions about these Terms should be directed to support@hyaia.com.",
    },
  },

  mini_navbar: {
    contact_us_nav_text: "Contact with us",
    partners_nav_text: "PARTNERS",
    company_nav_text: "COMPANY",
    contact_nav_text: "CONTACT",
    schedule_demo_text: "Schedule a demo",
  },

  navbar: {
    awards: {
      title: "AWARDS",
    },

    examples: {
      title: "EXAMPLES",
    },

    produtos_menu: {
      title: "PRODUCT",
      connectors: {
        title: "Data & Connectors",
        conectors_link_text: "Connectors",
        datasources_link_test: "Data Sources",
        datamanagement_link_test: "Data Management",
        realdata_link_test: "Real Time Data",
      },
      dashboards_and_reports: {
        title: "Dashboards & Reports",
        interactive_dashboard: {
          title: "Interactive Dashboards",
        },
        mobile_dashboards: {
          title: "Dashboards for Mobile",
        },

        dashboard_design: {
          title: "Agile and Easy Designer Dashboards",
        },
      },
      automation: {
        title: "Automation",
        publish_and_share: {
          title: "Publish and Share",
        },

        scheduling: {
          title: "Scheduling and Alerts",
        },

        security_and_management: {
          title: "User Management",
        },

        advanced_security: {
          title: "Advanced Security",
        },
      },
    },

    solutions: {
      title: "SOLUTIONS",
      sectors: {
        title: "By Sector",
        retail_text: "Retail",
        public_sector_text: "Public Sector",
        education_text: "Education",
        industry_text: "Industry",
        telecom_text: "Telecom",
        health_text: "Health",
        financial_text: "Financial Companies",
        ecommerce_text: "E-commerce",

        title_2: "By data",
        database_text: "Database",
        financials_operational: "Financial and Operational Chains",
      },
    },

    modules: {
      title: "MODULES",
    },

    suport: {
      title: "SUPPORT",
      options: {
        faq_text: "FAQ",
        ticket_text: "Online Assistance and Support Tickets",
        chat_text: "Integrated Chat with our Experts",
        integrations_text: "Integration API",
      },
    },
  },

  cookie_consent: {
    section_text_1: `We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking “Accept”, you consent to the use of ALL the cookies. `,
    button_text: "ACCEPT",
  },

  request_a_demo: {
    title: "FILL IN THE FORM BELOW, WE WILL CONTACT YOU: ",
    placeholders: {
      name_placeholder_text: "FULL NAME: ",
      email_placeholder_text: "E-MAIL: ",
      phone_placeholder_text: "TELEPHONE: ",
      company_placeholder_text: "COMPANY: ",
      comments_placeholder_text: "COMMENTS: ",
    },
    messageSucess: {
      sucess: "Message sent successfully:",
      validation_error_text: "Error: fields cannot be blank"
    },
  },

  footer: {
    change_language: "Change Language",
    social_media: {
      follow_us_text: "Follow us on social media:            ",
    },
    suport_and_services: {
      title: "SERVICES & RESOURCES",
      partners_text: "Partners",
      data_connection_text: "Data Connection",
    },
    privacy_and_terms: {
      privacy_policy: "Privacy Policy",
      terms_of_use: "Terms of Use",
    },
  },
};

const translation = { translations: ENGLISH_TRANSLATION };

export default translation;
